import { useBaseTopicRequestBuilder } from '../../utils/useBaseTopicRequestBuilder';
import { useAppSelector } from 'src/utils/Hooks';
import { TopicRequestBuilder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils/TopicRequestBuilder';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TOPIC_QUERY_KEYS } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Settings/topicQueryKeys';

export interface GetTrafficByCategoryResponseRecord {
  categoryId: number;
  subcategoryId: number;
  totalTraffic: number;
  organicTraffic: number;
  paidTraffic: number;
  otherTraffic: number;
  paidAdSpend: number;
  paidAdSales: number;
}

export interface GetTrafficByCategoryResponse {
  records: GetTrafficByCategoryResponseRecord[];
}

/**
 * Get the traffic by category for topics
 */
export const useTopicTrafficByCategory = ({ sortField }: { sortField: string }) => {
  const { startWeek, endWeek } = useAppSelector((state) => state.mainTimePeriod);
  const { startWeek: comparisonStartWeek, endWeek: comparisonEndWeek } = useAppSelector(
    (state) => state.comparisonTimePeriod
  );
  const baseRequest = useBaseTopicRequestBuilder();

  const categoriesRequest = baseRequest.setStartWeekId(startWeek).setEndWeekId(endWeek).setSortField(sortField).build();

  const categoriesComparisonRequest = new TopicRequestBuilder(categoriesRequest)
    .setStartWeekId(comparisonStartWeek)
    .setEndWeekId(comparisonEndWeek)
    .build();

  const { data, isLoading } = useQuery({
    queryKey: [TOPIC_QUERY_KEYS.all, `${sortField}CategoriesGrid`, categoriesRequest, categoriesComparisonRequest],
    queryFn: async () => {
      const endpoint = '/api/beacontopics/GetCategoryMetrics';
      const [{ data: response }, { data: comparisonResponse }] = await Promise.all([
        axios.post<GetTrafficByCategoryResponse>(endpoint, categoriesRequest),
        axios.post<GetTrafficByCategoryResponse>(endpoint, categoriesComparisonRequest)
      ]);

      return [response, comparisonResponse];
    },
    staleTime: 1000 * 60 * 5 // 5 minutes
  });

  const response = data ?? [{ records: [] }, { records: [] }];

  return {
    response,
    isLoading
  };
};
